import { post, get, put, del } from "@/utils/request";

// 培训任务列表考官
export function getTrainList(data) {
    return get("/api/exam/cultivate", data);
}
// 培训任务列表考生
export function getExamineeTrainList(data) {
    return post("/api/exam/cultivate/getExamineeCultivateList?pageSize=" + data.pageSize + "&pageNum=" + data.pageNum, data);
}
// 培训任务详情列表
export function getTrainTaskDetailList(data) {
    return post("/api/exam/cultivate/cultivateDetail?pageSize=" + data.pageSize + "&pageNum=" + data.pageNum, data);
}

// 预览培训任务
export function previewTrainTask(data) {
    return get("/api/exam/cultivate/showCultivate/" + data.id);
}

// 保存培训文档查看进度
export function saveFileProcess(data) {
    return get("/api/exam/cultivate/saveWatchProcess", data);
}
// 保存/提交培训题目
export function savePracticePaper(data) {
    return post("/api/exam/cultivate/savePracticePaper", data);
}
// 获取负责人列表
export function getUserList(data) {
    return get("/api/exam/admin/adminList", data);
}

// 获取蜂巢终端人列表 - 未分配列表
/* 
id培训任务id
searchStr 终端人姓名、手机号、邮箱、团队名称
*/
export function getCultivateAssignableUserList(data) {
    return post(`/api/exam/cultivate/assignableUserList?pageNum=${data.pageNum}&pageSize=${data.pageSize}`, data);
}

// 已分配列表
/* 
id 培训任务id
searchStr	终端人姓名、手机号、邮箱、团队名称
*/
export function getCultivateAssignedUserList(data) {
    return post(`/api/exam/cultivate/assignedUserList`, data);
}

// 分配
/* 
id 培训任务id
searchStr	终端人姓名、手机号、邮箱、团队名称
*/
export function getCultivateDistributeUser(data) {
    return post("/api/exam/cultivate/distributeUser", data);
}

//关联考试时是否有权限查看其他培训任务
export function limitTrainTask(id) {
    return get("/api/exam/cultivate/isShowCultivate?cultivateId=" + id);
}


